import { router } from '@inertiajs/vue3';

export function useAppNavigation() {
    const getHomeRoute = () => route('home');

    const goToHome = () => router.visit(getHomeRoute());

    return { getHomeRoute, goToHome };
}
